<template>
  <div>
    <Logo></Logo>
    <!-- <FirstHeader/> -->
    <div><img :src="this.image" class="bg"></img></div>
    <JoinBar></JoinBar>
    <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
import JoinBar from '../join/join_components/joinBar.vue'
// import FirstHeader from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import api from '@/utils/api'
export default {
  name: 'Join',
  components: {
    JoinBar,
    // FirstHeader
    Tabbar,
    Logo,
  },
  created () {
    this.local()
  },
  data () {
    return {
      image: '',
    }
  },
  methods: {
    local () {
      var storage = window.localStorage
      if (!storage) {
        return false
      } else {
        if (storage.getItem('join')) {
          var join = JSON.parse(storage.getItem('join'))
          if (join.image.code === 200) {
            this.image = join.image.data.image
          }
          if (new Date().getTime() - join.time > 6500000) {
            storage.removeItem('about')
          }
        }
        else {
          this.getJoin()
        }
      }
    },
    async getJoin () {
      const { data:data } = await api.getJoin()
      var curr = new Date().getTime()
      window.localStorage.setItem('join',JSON.stringify({
          time:curr,
          image:data
      }))
      if (data.code === 200) {
        this.image = data.data.image
      }
    }
  },
}
</script>

<style scoped>
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
</style>
